module.exports = __webpack_public_path__ + "img/shared-icon.8362bc5d.svg";